import React from 'react';
import PageLayout from './PageLayout';
import { useTranslation } from 'react-i18next';
import pythonImage from '../images/python.png';
import CImage from '../images/C.jpg';
import javascriptImage from '../images/js.png';
import RaspberryPiImage from '../images/raspberrypi.png';
import ArduinoImage from '../images/arduino-logo.svg';
import ReactImage from '../images/React.png';
import HTMLImage from '../images/html.png';
import CSSImage from '../images/css.png';
import NextjsImage from '../images/nextjs-2.svg';

const skillImages = [
  pythonImage,
  javascriptImage,
  CImage,
  RaspberryPiImage,
  ArduinoImage,
  ReactImage,
  HTMLImage,
  CSSImage,
  NextjsImage
];

const Skill = () => {
  const { t } = useTranslation();

  const translatedSkills = t('skill.skillsData', { returnObjects: true });
  const skillsData = Array.isArray(translatedSkills)
    ? translatedSkills.map((item, index) => ({
        ...item,
        image: skillImages[index] || pythonImage
      }))
    : [];

  const qualificationsData = t('skill.qualificationsData', { returnObjects: true }) || [];

  return (
    <PageLayout>
      <div className='container-fluid text-center'>
      
        {/* --- スキル セクション --- */}
        <section id="skills" className="my-5">
          <h2 className="title page-first-heading">{t('skill.skills')}</h2>
          <div className="skills-grid">
            {skillsData.map((skill, idx) => (
              <div className="skill-card" key={idx}>
                <img src={skill.image} alt={skill.alt} />
                <h4>{skill.title}</h4>
                <p>{skill.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* --- 資格セクション --- */}
        <section id="qualifications" className="my-5">
          <h2 className="title">{t('skill.licenses')}</h2>
          <ul className="list-group">
            {Array.isArray(qualificationsData) && qualificationsData.map((qual, idx) => (
              <li className="list-group-item d-flex justify-content-between align-items-center" key={idx}>
                {qual.name}
                <span className="badge bg-secondary">{qual.date}</span>
              </li>
            ))}
          </ul>
        </section>

      </div>
    </PageLayout>
  );
};

export default Skill;